const options = [
  {type: "knight", abbrev: "N"},
  {type: "bishop", abbrev: "B"},
  {type: "rook", abbrev: "R"},
  {type: "queen", abbrev: "Q"}
];

export default options;